import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { FileBadge, Download } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "./ui/card";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("mgbApprenantToken")}` });

export const DocumentsApprenant = () => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/apprenant/documents`, { headers: authHeaders() });
      setItems(res.data);
    } catch { /* aucun dossier lié */ }
  }, []);
  useEffect(() => { load(); }, [load]);

  const download = async (dossierId, type) => {
    setBusy(`${dossierId}-${type}`);
    try {
      const res = await axios.get(`${API}/apprenant/documents/${dossierId}/${type}.pdf`, { headers: authHeaders(), responseType: "blob" });
      const match = (res.headers["content-disposition"] || "").match(/filename="?([^";]+)"?/);
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = match ? match[1] : `MGB-School_${type}.pdf`;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } catch {
      toast.error("Téléchargement impossible");
    } finally {
      setBusy(null);
    }
  };

  if (items.length === 0) return null;
  return (
    <Card data-testid="documents-section">
      <CardHeader>
        <CardTitle className="text-[#003087] flex items-center gap-2"><FileBadge className="h-5 w-5" /> Mes documents de formation</CardTitle>
        <CardDescription>Convocation, contrat, attestation, certificat et facture — disponibles au fil de votre parcours.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {items.map((d) => (
          <div key={d.dossier_id} data-testid={`documents-dossier-${d.dossier_id}`}>
            <p className="font-semibold text-sm text-[#003087] mb-2">
              {d.formation_code} — {d.formation_title}
              {d.date_debut && <span className="text-gray-500 font-normal"> · session du {new Date(d.date_debut).toLocaleDateString("fr-FR")}</span>}
            </p>
            <div className="flex flex-wrap gap-2">
              {d.documents.map((doc) => (
                <Button key={doc.type} size="sm" variant="outline" className="border-[#003087] text-[#003087] hover:bg-[#003087] hover:text-white" disabled={busy === `${d.dossier_id}-${doc.type}`} onClick={() => download(d.dossier_id, doc.type)} data-testid={`apprenant-doc-${d.dossier_id}-${doc.type}`}>
                  <Download className="h-3.5 w-3.5 mr-1" /> {doc.label}
                </Button>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
